import * as React from 'react'
import FormContext from './formContext'

type Injected = { form?: React.RefObject<HTMLFormElement> }

const withForm: Utils.PropInjector<Injected> = (Component) => {
  return function(props) {
    const form = React.useContext(FormContext)
    const injectedProps = { ...props, form } as any as React.ComponentProps<typeof Component>
    return <Component {...injectedProps} />
  }
}

export default withForm
